import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {loadVip} from '../../../reducers/vip20/actions';
import Selector from '../../../selectors/pages/vip20';
import PageContainer from '../page-container';
import Components from '../../components';

import Top from './top';
import Bonuses from './bonuses';

import Triggers from '../../../lib/triggers';

export default () => {
    const {loaded} = useSelector(Selector),
          dispatch = useDispatch(),
          location = useLocation();

    useEffect(() => {
        if(!loaded) {
            dispatch(loadVip());
        } else {
            Components.Loader.close();
            Components.Loader.closePage();
        }
    }, [loaded]);

    useEffect(() => {
        Triggers.page_view({
            page: "vip"
        });
    }, [location]);
 
    return (
        <PageContainer>
            <Components.Loader.Page />
            {loaded && (
                <div className="vip-20">
                    <Components.Winners />
                    <Top />
                    <Bonuses />

                    <Components.DepositBonus />
                    <Components.Footer />
                </div>
            )}
        </PageContainer>
    )
}